import { instance, instanceWithAuth, multipartInstanceWithAuth, blobResponseInstanceWithAuth } from "@/api/index";

function signUp(signUpdata) {
  return instance.post("users/sign-up", signUpdata)
}

function signUpBizNoUpload(signUpBizNoRequest) {
  return instance.post("users/sign-up/biz-uploads", signUpBizNoRequest)
}

function refreshTokenUser() {
  return instance.get("/auth/refresh", { withCredentials: true });
}

function findId(findIdData) {
  return instance.post("/users/find-id", findIdData);
}

function findPwd(findPwdData) {
  return instance.post("/users/find-pwd", findPwdData);
}

function updatePwd(updatePwdData) {
  return instanceWithAuth.post("/users/update-pwd", updatePwdData);
}

function userUpdatePwd(userUpdatePwd) {
  return instance.post("/users/user-update-pwd", userUpdatePwd);
}

function duplicateIdCheck(userData) {
  return instance.get("/users/id-check", { params: userData });
}

function duplicateEmlCheck(userData) {
  return instance.get("/users/email-check", { params: userData });
}

function duplicateTelNoCheck(userData) {
  return instance.get("/users/tel-no-check", { params: userData });
}

function updateMyInfo(updateUserInfo) {
  return instanceWithAuth.post("/users/update-info", updateUserInfo);
}

function searchAddress(searchData) {
  return instance.get("/users/search-address", { params: searchData });
}

function getUserCmpInfo(data) {
  return instance.get("/users/cmp-info", { params: data });
}

function getUserInfo(data) {
  return instanceWithAuth.get("/users/get-user-info", { params: data });
}

function getMyFiles() {
  return instanceWithAuth.get("/users/get-files");
}

function deleteMyFiles(seqList) {
  return instanceWithAuth.post("/users/delete-files", seqList);
}

function getMyFile(param) {
  return blobResponseInstanceWithAuth.get("/users/file", { params: param });
}

function uploadMyFiles(uploadFileRequest) {
  return instanceWithAuth.post("/users/upload-files", uploadFileRequest);
}

function getCountryCodes() {
  return instanceWithAuth.get("/users/country-codes");
}

function withdrawUser() {
  return instanceWithAuth.post("/users/withdraw");
}

function getNiceIdRequestUrl() {
  return instanceWithAuth.get("/niceid/url");
}
function getNiceIdAuthResult(params) {
  return instanceWithAuth.get("/niceid/result", { params: params });
}

function ssoLogin(params) {
  return instance.get("/auth/sso/login", { params: params });
}
function ssoRegisterCmp(formData) {
  return multipartInstanceWithAuth.post("/users/sso/cmp-register", formData);
}

function userPwdCheck(pwdCheck) {
  return instanceWithAuth.post("/users/pwd-check", pwdCheck);
}
export {
  signUp, signUpBizNoUpload, refreshTokenUser, findId, findPwd, userUpdatePwd, updatePwd, duplicateIdCheck,
  duplicateEmlCheck, duplicateTelNoCheck, updateMyInfo, searchAddress, getUserCmpInfo, getUserInfo, getNiceIdRequestUrl, getNiceIdAuthResult,
  withdrawUser, getMyFiles, deleteMyFiles, uploadMyFiles, getMyFile, getCountryCodes, ssoLogin, ssoRegisterCmp, userPwdCheck
};

